import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

document.documentElement.classList.add('no-scrollbar');
document.body.classList.add('no-scrollbar');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
